import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class AceModePillService {
  regExp = /\[aceModePill text="([^"]+)"\]/g;

  aceModePillParser = (content: string): string => {
    if (content && typeof content === 'string') {
      const matches = [...content.matchAll(this.regExp)];

      if (!matches.length) {
        return content;
      }

      matches.forEach((match) => {
        // Shortcode text lands inside markup the redactor later trusts, so it must stay text. The
        // CMS already entity-encodes it, so leave "&" alone to avoid double-encoding.
        const text = match[1].replace(/</g, '&lt;').replace(/>/g, '&gt;');
        const pill = `<span class="ace-mode-pill bg-ace-mode-linear text-vis-dark">${text}</span>`;
        content = content.replace(match[0], pill);
      });
    }

    return content;
  };
}
